module.exports = __webpack_public_path__ + "img/1.1fcf131b.png";